import React, { useEffect } from 'react';
import System from 'src/helper/system';
import { useBOMStore } from 'src/hooks/bom';
import BomListingHeader from './BomListing/BomListingHeader/BomListingHeader';
import BomTabsListing from './BomListing/BomTabsListing';
import useReduxState from "../../hooks/useReduxState";
import $ from "jquery";
import { isObject } from 'underscore';
import Constants from 'src/helper/Constants';
import BOMRepository from 'src/repository/BOMRepository';
import ShowAlert from 'src/component/Global/ShowAlert';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";
import { useSelector } from "react-redux";


const isReRunPartMatch = System.getParams().isReRunPartMatch ? System.getParams().isReRunPartMatch : true;
const { storageName: { FLASH_MESSAGE, FLASH_MESSAGE_REMATCH, BOM_UPLOAD_FILE } } = System

export function BomTabsList() {
    const [top] = useReduxState({}, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT', true);
    const [{ bom_detail_by_bom_id, bomSortByUpdatedDate, bom_project_list }, { get_bom_detail_by_bom_id, get_bom_detail_by_bom_id_with_type }] = useBOMStore();
    const [{  }, {system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const { bomDetailPageTabs } = Constants
    const bomTabType = System.getParams().__c_BomTabList || bomDetailPageTabs.BomExactMatchTable.content;
    const bom_id = System.getParams().bomId

    useEffect(() => {
        async function fetchHere() {
            if (bom_id) {
                let c = System.getParams();
                delete c.go;
                history.pushState(null, null, '?' + $.param(c));
                let res = await get_bom_detail_by_bom_id({ bomId: bom_id })
                if (!res.payload || res.payload === null) {
                    window.history.back();
                    return;
                }
                if (localStorage.getItem(FLASH_MESSAGE)) {
                    system_alert_indicator({
                        name: 'FLASH_MESSAGE',
                        message: localStorage.getItem(FLASH_MESSAGE),
                        type: BOMRepository.getBOMAlertClass(localStorage.getItem(FLASH_MESSAGE))
                    })
                    // Add New Local Storage for Rematch
                    localStorage.setItem(FLASH_MESSAGE_REMATCH, localStorage.getItem(FLASH_MESSAGE));
                    localStorage.removeItem(FLASH_MESSAGE);
                }
            } else {
                window.history.back()
            }
        }

        fetchHere()
    }, []);

    useEffect(() => {
        if (bom_detail_by_bom_id !== undefined && bom_detail_by_bom_id === null) {
            window.history.back()
        }
    }, [bom_detail_by_bom_id]);

    useEffect(() => {
        async function f() {
            let top_here = 10;
            if (top[bomDetailPageTabs[bomTabType].api_fetch_type] && top[bomDetailPageTabs[bomTabType].api_fetch_type].top) {
                top_here = top[bomDetailPageTabs[bomTabType].api_fetch_type].top;
            }
            top_here = top_here === 10 ? 20 : top_here;
            let param = {
                bomId: bom_id,
                isReRunPartMatch,
                matchType: bomDetailPageTabs[bomTabType].api_fetch_type,
                top: top_here
            }

            if (bomSortByUpdatedDate) {
                param.sortColumn = "updated_date"
                param.sortOrder = "desc"
            }
            let res = await get_bom_detail_by_bom_id_with_type(param);
            if (localStorage.getItem(BOM_UPLOAD_FILE)) {
                localStorage.removeItem(BOM_UPLOAD_FILE);
                let nothing_found_for_Exact_tab = false;
                try {
                    if (res.payload.data.Exact.count < 1) {
                        nothing_found_for_Exact_tab = true;
                    }
                } catch (e) {
                }

                if (localStorage.getItem(FLASH_MESSAGE_REMATCH) && nothing_found_for_Exact_tab === false) {
                    localStorage.removeItem(FLASH_MESSAGE_REMATCH);
                }
            }
        }

        if (top && isObject(top) && Object.keys(top).length > 0) {
            const { Exact: { top: exactTop }, Multiple: { top: multipleTop }, NoMatch: { top: nomatchTop } } = top;
            if (exactTop !== 20 || multipleTop !== 20 || nomatchTop !== 20) {
                f()
            }
        }
    }, [top]);

     /**
   * Owner : Ramya
   * Date  : 31/07/2024
   * Note  : BomFileUpload, RenameBOM, BOMOpened, Quickly Add a part - Adobe script.
   *
   */

  const [{inventoryList,pricing_list }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
 
  const getPricing = (ele) => {
    let priceValues = get_pricing_by_id({ uniqueId: ele.bomDetailId ? ele.bomDetailId : ele.ItemNumber })
    return priceValues && priceValues[0];
  }


  const BomDetails = useSelector(
    (state) => state.entities.model_BOM.bomDetailByBomID
  );
  const bomDetailsTable = useSelector(
    (state) => state.entities.model_BOM.bomDetailByBomIDWithType
  );
  if (
    BomDetails?.bomId &&
    Object.keys(bomDetailsTable).length &&
    Object.keys(inventoryList).length &&
    System.checkPriceValues(pricing_list)
  ) {
    let storageEvent = localStorage.getItem("adobeEventType") ;
    if (storageEvent) {
      let bomDetails = { ...BomDetails };
      if (bom_project_list) {
        bomDetails.projectName =
          bom_project_list[bom_detail_by_bom_id.projectId]?.projectName;
      }
      if (storageEvent === "bomOpened") {
        let prodDetails = [];
        if (bomDetailsTable?.Exact?.records) {
          Object.entries(bomDetailsTable?.Exact?.records).map((data, i) => {
            prodDetails.push(data[1]);
          });
        }
        prodDetails.map((data, ind) => {
          let copyObj = { ...data };
          copyObj.qas = get_inventory_by_id(data.ItemNumber)?.inventoryQty;
          let priceVal = getPricing(data);
          copyObj.priceSource = priceVal?.priceSource;
          copyObj.unitPrice = copyObj?.unitPrice || priceVal?.marketPrice;
          copyObj.subtotal = copyObj?.subtotal || (priceVal?.marketPrice * priceVal?.quantity);
          prodDetails[ind] = copyObj;
        });

        if (
          Object.keys(bomDetails).length &&
          Object.keys(bomDetailsTable).length &&
          prodDetails?.length
        ) {
          HelperAdobeEvent.trackingAdobeEvent({
            bomDetails,
            bomDetailsTable,
            prodDetails,
          });
        }
      } 
      else if (storageEvent === "addToBOM") {
        let copyProdDetails = [];
        if (bomDetailsTable?.Exact?.records) {
          Object.entries(bomDetailsTable?.Exact?.records).map((data, i) => {
            copyProdDetails.push(data[1]);
          });
        }
        bomDetails.projectId = bomDetails.bomId || bomDetails.projectId;
        if (bom_project_list) {
          bomDetails.projectName =
            bom_project_list[bomDetails.projectId]?.projectName;
        }
        let prodDetails = [copyProdDetails.pop()];
        prodDetails.map((data, ind) => {
          let copyObj = { ...data };
          copyObj.qas = get_inventory_by_id(data.ItemNumber)?.inventoryQty;
          let priceVal = getPricing(data);
          copyObj.priceSource = priceVal?.priceSource;
          copyObj.unitPrice = copyObj?.unitPrice || priceVal?.marketPrice;
          copyObj.subtotal = copyObj?.subtotal || (priceVal?.marketPrice * priceVal?.quantity);
          prodDetails[ind] = copyObj;
        });

       
    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({
        prodDetails,
        bomDetails,
      });
    }
      } 
      else if (storageEvent === "bomQuicklyAddPart") {
        let prodDetails = localStorage.getItem("prodPayload") ;
        prodDetails = JSON.parse(prodDetails);
        prodDetails.qas = get_inventory_by_id(prodDetails.ItemNumber)?.inventoryQty || 0;
        let priceVal = getPricing(prodDetails);
        prodDetails.priceSource = priceVal?.priceSource;
        prodDetails.unitPrice = priceVal?.marketPrice;
        prodDetails.quantity  = priceVal?.quantity;
        if (
          Object.keys(bomDetails).length &&
          Object.keys(bomDetailsTable).length &&
          Object.keys(prodDetails)?.length
        ) {
          HelperAdobeEvent.trackingAdobeEvent({
            bomDetails,
            bomDetailsTable,
            prodDetails,
          });
          localStorage.removeItem("prodPayload")
        }
      } else if(storageEvent === "renameBom" || storageEvent === "bomFileUpload"){
        if (
          Object.keys(bomDetails).length &&
          Object.keys(bomDetailsTable).length
        ) {
          HelperAdobeEvent.trackingAdobeEvent({
            bomDetails,
            bomDetailsTable,
          });
        }
      }
    }
  }

    return (
        <>
            <div className="logged-screen">

                <div className="">

                    <div id="main" className="">

                        {/* BOM-file-listing page */}
                        <div className="bom-copy">
                            <BomListingHeader />
                            <ShowAlert />
                            <BomTabsListing />

                        </div>
                    </div>
                </div>
            </div>


        </>
    );

}
